const messagesHi = {
  about: 'के बारे में',
  acceptanceCriteria: 'स्वीकृति मानदंड',
  accomplishments: 'उपलब्धियां',
  actions: 'क्रियाएं',
  activity: 'गतिविधि',
  activatePod: 'POD सक्रिय करें',
  activePods: 'सक्रिय POD',
  add: 'जोड़ें',
  addBlocker: 'अवरोधक जानकारी जोड़ें',
  addingCandidateWait: 'उम्मीदवार जोड़ा जा रहा है कृपया प्रतीक्षा करें...',
  addPortfolio: 'पोर्टफोलियो जोड़ें',
  addStakeholder: 'हितधारक जोड़ें',
  addVideoUpdate: 'वीडियो अपडेट जोड़ें',
  findAgents: 'एजेंट खोजें',
  all: 'सभी',
  allReporters: 'सभी रिपोर्टर',
  allRepoCheckins: 'सभी रेपो चेकइन',
  approve: 'अनुमोदन',
  approved: 'अनुमोदित',
  approvalRequests: 'अनुमोदन अनुरोध',
  approvedPRCount: 'अनुमोदित PR संख्या',
  assignedItems: 'सौंपे गए आइटम',
  availability: 'उपलब्धता',
  availableDate: 'उपलब्ध तारीख',
  backToPods: 'मेरे POD पर वापस जाएं',
  basicInformation: 'मूल जानकारी',
  blocker: 'अवरोधक',
  blockerDetails: 'अवरोधक विवरण',
  blockers: 'अवरोधक',
  board: 'बोर्ड',
  browseTalent: 'प्रतिभा ब्राउज़ करें',
  bugs: 'बग',
  calendlyUrl: 'Calendly URL',
  cancel: 'रद्द करें',
  candidates: 'उम्मीदवार',
  categories: 'श्रेणियां',
  certifications: 'प्रमाणपत्र',
  certificationUrl: 'प्रमाणपत्र URL',
  checkBoxBlocker: 'यदि यह एक अवरोधक है तो इस बॉक्स को चेक करें',
  ciCdPipeline: 'CI/CD पाइपलाइन',
  clear: 'साफ़ करें',
  client: 'क्लाइंट',
  clickHereUploadVideoClip: 'वीडियो क्लिप अपलोड करने के लिए यहां क्लिक करें!',
  cloudCost: 'क्लाउड लागत',
  code: 'कोड लाइनें',
  codeSmells: 'कोड स्मेल्स',
  commentHere: 'यहां टिप्पणी करें...',
  category: 'श्रेणी',
  comments: 'टिप्पणियां',
  companyName: 'कंपनी का नाम',
  copied: 'कॉपी किया गया!',
  copyright: 'कॉपीराइट © 2025-वर्तमान Brilli Global, Inc. सभी अधिकार सुरक्षित।',
  copyToClipboard: 'क्लिपबोर्ड पर कॉपी करें',
  cost: 'लागत',
  costDetails: 'लागत विवरण',
  country: 'देश',
  create: 'बनाएं',
  createArt: 'ART बनाएं',
  createGig: 'समाधान बनाएं',
  createPod: 'POD बनाएं',
  createProfile: 'प्रोफाइल बनाएं',
  createProfileOpportunity: 'विभिन्न रिमोट वर्क के अवसरों के लिए हमारे प्रतिभा डेटाबेस में अपनी प्रोफाइल बनाएं।',
  createTask: 'कार्य बनाएं',
  createYourOwnPod: 'अपना खुद का POD बनाएं और प्रोजेक्ट्स ब्राउज़ करें',
  creatingProfile: 'प्रोफाइल बनाई जा रही है',
  currency: 'मुद्रा',
  currentlyAvailable: 'वर्तमान में उपलब्ध',
  currentWeek: 'वर्तमान सप्ताह',
  dashboard: 'डैशबोर्ड',
  date: 'तारीख',
  dateRangeFilter: 'दिनांक सीमा फिल्टर',
  deactivatePod: 'POD निष्क्रिय करें',
  deactivateToUpdate: 'POD को अपडेट करने के लिए निष्क्रिय करें!',
  defects: 'दोष',
  delete: 'हटाएं',
  deletePod: 'POD हटाएं',
  description: 'विवरण',
  detailsForGitHubRepo: 'GitHub रिपॉजिटरी के लिए विवरण',
  done: 'बंद करें',
  Done: 'पूर्ण',
  doraMetrics: 'Dora मेट्रिक्स',
  dueDate: 'नियत तारीख',
  duplicatedLinesDensity: 'डुप्लिकेट लाइनों का घनत्व',
  edit: 'संपादित करें',
  education: 'शिक्षा',
  educationAndCertifications: 'शिक्षा और प्रमाणपत्र',
  email: 'ईमेल',
  podTime: 'POD समय',
  createHub: 'हब बनाएं',
  createSolution: 'समाधान बनाएं',
  podVelocity: 'POD वेग',
  podBlockers: 'POD अवरोधक',
  podsync: 'POD सिंक',
  endDate: 'समाप्ति तारीख',
  enterEmailToInvite: 'आमंत्रित करने के लिए ईमेल दर्ज करें',
  enterPodMission: 'POD मिशन दर्ज करें',
  enterPodName: 'POD नाम दर्ज करें',
  enterStoryDescription: 'कहानी विवरण दर्ज करें',
  executionDate: 'निष्पादन तारीख',
  executionID: 'निष्पादन ID',
  externalPod: 'बाहरी POD',
  fileNameNoSpaces: 'फाइल नाम में स्पेस नहीं होना चाहिए',
  fileUpload: 'फाइल अपलोड',
  findBestFreelancers: 'अपने प्रोजेक्ट्स को तेज गति से पूरा करने के लिए सर्वश्रेष्ठ फ्रीलांसर या प्रतिभा POD खोजें!',
  findBestPod: 'अपने अनुभव/कौशल से मेल खाने वाले POD खोजें',
  findPods: 'POD खोजें',
  findTalent: 'प्रतिभा खोजें',
  findYourBestTalentPod: 'अपना सर्वश्रेष्ठ प्रतिभा POD खोजें',
  firstName: 'पहला नाम',
  focus: 'फोकस',
  gitHubRepo: 'GitHub रेपो',
  gitHubUsername: 'GitHub उपयोगकर्ता नाम',
  github: 'Github',
  githubSummary: 'GitHub सारांश',
  githubUrl: 'Github URL',
  githubUser: 'GitHub उपयोगकर्ता',
  giveRating: 'रेटिंग दें',
  globalWorkPlatform: 'वैश्विक कार्य प्लेटफॉर्म',
  home: 'होम',
  hoursPerWeek: 'प्रति सप्ताह घंटे',
  inactivePod: 'निष्क्रिय POD',
  individual: 'व्यक्तिगत',
  industry: 'उद्योग',
  inProgress: 'प्रगति में',
  institute: 'संस्थान',
  internalPod: 'आंतरिक POD',
  invite: 'आमंत्रित करें',
  invoices: 'चालान',
  issueKey: 'मुद्दा कुंजी',
  issueStatus: 'मुद्दा स्थिति',
  issueSummary: 'मुद्दा सारांश',
  jiraIssue: 'Jira मुद्दा',
  jiraIssues: 'Jira मुद्दे',
  jiraItem: 'Jira आइटम',
  jiraTimeDetails: 'समय लॉग',
  jiraUsername: 'Jira उपयोगकर्ता नाम',
  keepDoing: 'करते रहें',
  keyword: 'कीवर्ड',
  languageSpoken: 'बोली जाने वाली भाषा',
  lastName: 'अंतिम नाम',
  latestSprintVelocity: 'नवीनतम स्प्रिंट वेग',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn URL',
  linesOfCodeByDay: 'दिन के अनुसार कोड लाइनें',
  listOfTalents: 'प्रतिभाओं की सूची',
  loading: 'लोड हो रहा है',
  loadingAcceptanceCriteria: 'स्वीकृति मानदंड लोड हो रहे हैं',
  loadingStoryDescription: 'कहानी विवरण लोड हो रहा है',
  loadingTestCases: 'टेस्ट केस लोड हो रहे हैं',
  logOut: 'लॉग आउट',
  login: 'लॉगिन',
  manage: 'प्रबंधन',
  manageActivities: 'अपनी दैनिक POD गतिविधियों और अपडेट्स का प्रबंधन करें',
  manageProfile: 'प्रोफाइल प्रबंधन',
  manageProfileHere: 'यहां अपनी प्रोफाइल का प्रबंधन करें',
  managePod: 'POD प्रबंधन',
  managePods: 'अपने सभी POD और उनकी गतिविधियों का प्रबंधन करें',
  markComplete: 'पूर्ण चिह्नित करें',
  middleName: 'मध्य नाम',
  myPods: 'मेरे POD',
  myTasks: 'मेरे कार्य',
  name: 'नाम',
  ncloc: 'Ncloc',
  newActivityUpdate: 'नई गतिविधि अपडेट',
  next: 'अगला',
  noArtOptionsAvailable: 'कोई ART विकल्प उपलब्ध नहीं',
  noBlockers: 'कोई अवरोधक नहीं हैं',
  noCandidates: 'कोई उम्मीदवार नहीं जोड़े गए',
  noCandidatesAddedToPod: 'POD में कोई उम्मीदवार नहीं जोड़े गए!',
  noCandidateReviews: 'कोई उम्मीदवार समीक्षा नहीं है।',
  noData: 'कोई डेटा नहीं',
  noDataAvailable: 'कोई डेटा उपलब्ध नहीं',
  noExperience: 'कोई अनुभव नहीं',
  noMatchingPods: 'कोई मेल खाने वाले POD उपलब्ध नहीं हैं',
  noNotifications: 'कोई सूचना नहीं है',
  noPodActivity: 'आपकी कोई POD गतिविधि नहीं है',
  noPods: 'आपका कोई POD नहीं है',
  noPodTasks: 'आपके कोई POD कार्य नहीं हैं',
  noReviews: 'कोई समीक्षा नहीं है।',
  noStakeholders: 'इस POD के लिए कोई हितधारक नहीं हैं',
  noSubscription: 'आपकी कोई सब्सक्रिप्शन योजना नहीं है',
  noVideoAvailable: 'कोई वीडियो उपलब्ध नहीं',
  notifications: 'सूचना प्राप्तकर्ता',
  otherInformation: 'अन्य जानकारी',
  pending: 'लंबित',
  pendingPods: 'लंबित POD',
  phoneNumber: 'फोन नंबर',
  pipelineExecutionDetails: 'पाइपलाइन निष्पादन विवरण',
  pipelineName: 'पाइपलाइन नाम',
  pipelineVersion: 'पाइपलाइन संस्करण',
  pleaseEnterStoryDescription: 'कृपया कहानी विवरण दर्ज करें और सबमिट पर क्लिक करें',
  POD: 'POD',
  podActivities: 'POD गतिविधियां',
  podActivity: 'POD गतिविधि',
  podAnalytics: 'POD विश्लेषण',
  podAssist: 'POD सहायता',
  podAutomation: 'POD स्वचालन',
  podBoard: 'POD बोर्ड',
  podCategories: 'POD श्रेणियां',
  podDescription: 'POD विवरण',
  podExperience: 'POD अनुभव',
  podFeedback: 'POD फीडबैक',
  podMetrics: 'POD मेट्रिक्स',
  podName: 'POD नाम',
  podQuery: 'POD क्वेरी',
  podRequests: 'POD अनुरोध',
  podRetro: 'POD रेट्रो',
  podSize: 'POD आकार',
  podTasks: 'POD कार्य',
  podTaskDescription: 'POD कार्य विवरण',
  podTaskDueDate: 'POD कार्य नियत तारीख',
  podTaskName: 'POD कार्य नाम',
  podTaskOwner: 'POD कार्य स्वामी',
  podTaskStatus: 'POD कार्य स्थिति',
  podTechStack: 'POD तकनीकी स्टैक',
  podTeamMember: 'POD टीम सदस्य',
  podType: 'POD प्रकार',
  portfolio: 'पोर्टफोलियो',
  portfolioUrl: 'पोर्टफोलियो URL',
  post: 'पोस्ट',
  postActivity: 'गतिविधि पोस्ट करें',
  postPodActivity: 'POD गतिविधि पोस्ट करें',
  postRequirement: 'आवश्यकता पोस्ट करें',
  posting: 'पोस्ट किया जा रहा है...',
  postedDate: 'पोस्ट की गई तारीख',
  postedRequirements: 'आपकी पोस्ट की गई POD आवश्यकताएं',
  positionName: 'पद का नाम',
  prCount: 'PR संख्या',
  preferredWorkHours: 'पसंदीदा कार्य घंटे',
  prev: 'पिछला',
  previousPods: 'पिछले POD',
  previousWeek: 'पिछला सप्ताह',
  primarySkill: 'प्राथमिक कौशल',
  privacyPolicy: 'गोपनीयता नीति',
  privatePods: 'निजी POD',
  prSummary: 'PR सारांश',
  projectKey: 'प्रोजेक्ट कुंजी',
  profileLink: 'प्रोफाइल लिंक',
  profileVisibility: 'प्रोफाइल दृश्यता',
  public: 'सार्वजनिक',
  qualification: 'योग्यता',
  ratePerHour: 'प्रति घंटा दर',
  ratePerMonth: 'प्रति माह दर',
  recentSearches: 'हाल की खोजें',
  region: 'क्षेत्र',
  register: 'पंजीकरण',
  resetPassword: 'पासवर्ड रीसेट करें',
  restricted: 'प्रतिबंधित',
  retro: 'रेट्रो',
  review: 'समीक्षा और रेटिंग',
  revisionSummary: 'संशोधन सारांश',
  revisionURL: 'संशोधन URL',
  resume: 'रिज्यूमे',
  resumeLink: 'रिज्यूमे देखें',
  rowsPerPage: 'प्रति पृष्ठ पंक्तियां',
  save: 'सेव करें',
  search: 'खोजें',
  searchProjects: 'प्रोजेक्ट्स खोजें',
  secondarySkill: 'द्वितीयक कौशल',
  select: 'चुनें',
  selectArtName: 'ART नाम चुनें',
  selectAUser: 'उपयोगकर्ता चुनें',
  selectFilter: 'फिल्टर चुनें',
  applyFilters: 'फिल्टर लागू करें',
  selectItemsPerPage: 'प्रति पृष्ठ आइटम चुनें',
  selectJiraIssues: 'Jira मुद्दे चुनें',
  selectPod: 'POD चुनें',
  selectPodTeamMember: 'POD टीम सदस्य चुनें',
  selectPods: 'POD चुनें',
  services: 'सेवाएं',
  setting: 'सेटिंग',
  shareableLink: 'साझा करने योग्य लिंक',
  signUpToGetStarted: 'शुरुआत करने के लिए "साइन अप" करें!',
  getStarted: 'शुरुआत करें',
  skills: 'कौशल',
  skillsAndExpertise: 'कौशल और विशेषज्ञता',
  sonarqubeprojectkey: 'Sonarqube प्रोजेक्ट कुंजी',
  sonarqubeStats: 'Sonarqube आंकड़े',
  specialization: 'विशेषज्ञता',
  sprintVelocity: 'स्प्रिंट वेग',
  sprint: 'स्प्रिंट',
  spotsLeft: 'बचे हुए स्थान',
  startDate: 'प्रारंभ तारीख',
  startDoing: 'करना शुरू करें',
  status: 'स्थिति',
  stopDoing: 'करना बंद करें',
  storyDescription: 'कहानी विवरण',
  stories: 'कहानियां',
  submit: 'सबमिट',
  submittedDate: 'सबमिट की गई तारीख',
  submittedPRCount: 'सबमिट किए गए PR की संख्या',
  subscription: 'सब्सक्रिप्शन',
  talentApprovalRequests: 'प्रतिभा अनुमोदन अनुरोध',
  talentCode: 'प्रतिभा कोड',
  taskForm: 'कार्य फॉर्म',
  taskManager: 'कार्य प्रबंधक',
  taskName: 'कार्य नाम',
  tasks: 'कार्य',
  teamMember: 'टीम सदस्य',
  techStack: 'तकनीकी स्टैक',
  termsOfService: 'सेवा की शर्तें',
  testCases: 'टेस्ट केस',
  time: 'समय',
  timeLog: 'समय लॉग',
  timeSubmit: 'समय सबमिट',
  timeZone: 'समय क्षेत्र',
  toDo: 'करने के लिए',
  todaysFocus: 'आज का फोकस',
  totalLinesChangedLastWeek: 'पिछले सप्ताह कुल बदली गई लाइनें',
  totalLinesChangedThisWeek: 'इस सप्ताह कुल बदली गई लाइनें',
  totalPRCount: 'कुल PR संख्या',
  university: 'विश्वविद्यालय',
  update: 'अपडेट',
  updateProfileHere: 'यहां अपनी प्रोफाइल अपडेट करें',
  updatingVisibility: 'दृश्यता अपडेट की जा रही है...',
  upload: 'अपलोड',
  userStory: 'उपयोगकर्ता कहानी',
  validFrom: 'से वैध',
  validTill: 'तक वैध',
  talentexplorer: 'प्रतिभा एक्सप्लोरर',
  interviewrequests: 'साक्षात्कार अनुरोध',
  videoUrl: 'वीडियो URL',
  view: 'देखें',
  viewActivities: 'गतिविधियां देखें',
  viewDetails: 'विवरण देखें',
  viewPodActivities: 'POD गतिविधियां देखें',
  viewPodDetails: 'POD विवरण देखें',
  viewProfile: 'प्रोफाइल देखें',
  viewTasks: 'कार्य देखें',
  viewTimeEntries: 'समय प्रविष्टियां देखें',
  viewVideo: 'वीडियो देखें',
  visitFindTalent: 'कृपया "प्रतिभा खोजें" पृष्ठ पर जाएं और अपने POD में प्रतिभाशाली व्यक्तियों को जोड़ें।',
  vulnerabilities: 'कमजोरियां',
  welcome: 'Artemy.ai में आपका स्वागत है!',
  workExperience: 'कार्य अनुभव',
  yourPod: 'आपका POD',
  yourPods: 'आपके POD',
  yourPostedPodActivity: 'आपकी पोस्ट की गई POD गतिविधि',
  
  findTickets: 'टिकट खोजें',
  epics: 'महाकाव्य',
  date: 'तारीख',
  talent: 'प्रतिभा',
  focus: 'फोकस',
  startDate: 'प्रारंभ तारीख',
  endDate: 'समाप्ति तारीख',
  status: 'स्थिति',
  allStatus: 'सभी स्थिति',
  blocked: 'अवरुद्ध',
  onTrack: 'ट्रैक पर',
  activityDetails: 'गतिविधि विवरण',
  jiraIssues: 'Jira मुद्दे',
  todaysFocus: 'आज का फोकस',
  accomplishments: 'उपलब्धियां',
  blockers: 'अवरोधक',
  videoUpdate: 'वीडियो अपडेट',
  comments: 'टिप्पणियां',
  addBlockerInformation: 'अवरोधक जानकारी जोड़ें',
  blockerDetails: 'अवरोधक विवरण',
  cancel: 'रद्द करें',
  saveChanges: 'परिवर्तन सेव करें',
  selectJiraIssues: 'Jira मुद्दे चुनें',
  design: 'डिज़ाइन',
  development: 'विकास',
  testing: 'परीक्षण',
  bugFix: 'बग फिक्स',
  documentation: 'दस्तावेज़ीकरण',
  myPods: 'मेरे POD',
  postRetro: 'रेट्रो पोस्ट करें',
  newRetro: 'नया रेट्रो',
  startDoing: 'करना शुरू करें',
  stopDoing: 'करना बंद करें',
  keepDoing: 'करते रहें',
  viewRetros: 'रेट्रो देखें',
  podRetroFeedback: 'POD रेट्रो फीडबैक',
  selectSprint: 'स्प्रिंट चुनें',
  thisTaskIsBlocker: 'यह कार्य एक अवरोधक है',
  category: 'श्रेणी',
  taskCreatedSuccessfully: 'कार्य सफलतापूर्वक बनाया गया!',
  taskManagement: 'कार्य प्रबंधन',
  searchJiraIssues: 'JIRA मुद्दे खोजें...',
  creatingTask: 'कार्य बनाया जा रहा है...',
  createTask: 'कार्य बनाएं',
  description: 'विवरण',
  dueDate: 'नियत तारीख',
  commentsHistory: 'टिप्पणी इतिहास',
  noCommentsYet: 'अभी तक कोई टिप्पणी नहीं',
  writeAComment: 'एक टिप्पणी लिखें...',
  all: 'सभी',
  blockerStatus: 'अवरोधक स्थिति',
  blockedTasks: 'अवरुद्ध कार्य',
  unblockedTasks: 'अनावरुद्ध कार्य',
  clearDateRange: 'दिनांक सीमा साफ़ करें',
  selectDateRange: 'दिनांक सीमा चुनें',
  showAllTime: 'सभी समय दिखाएं',
  noTasksFound: 'कोई कार्य नहीं मिला',
  noLinkedIssues: 'कोई लिंक किए गए मुद्दे नहीं',
  timeSheet: 'समय पत्रक',
  podTimeSheet: 'POD समय पत्रक',
  userStory: 'उपयोगकर्ता कहानी',
  hours: 'घंटे',
  minutes: 'मिनट',
  actions: 'क्रियाएं',
  submitTimeEntries: 'समय प्रविष्टियां सबमिट करें',
  selectCategory: 'श्रेणी चुनें',
  selectStory: 'कहानी चुनें',
  addRow: 'पंक्ति जोड़ें',
  podSelection: 'POD चयन',
  selectPodToView: 'स्प्रिंट और प्रतिभा फिल्टर देखने के लिए POD चुनें',
  toDo: 'करने के लिए',
  podAssist: 'POD सहायता',
  inProgress: 'प्रगति में',
  done: 'पूर्ण',
  selectPodsRequired: 'POD चुनें (आवश्यक)',
  enterStoryDescription: 'कहानी विवरण दर्ज करें',
  podSyncSummaries: 'POD सिंक सारांश',
  enterMeetingUrl: 'मीटिंग URL दर्ज करें...',
  searchInSummaries: 'सारांश में खोजें...',
  dateAndTime: 'दिनांक और समय',
  quickTimeRange: 'त्वरित समय सीमा',
  sortByDate: 'तारीख के अनुसार क्रमबद्ध करें',
  selectTalents: 'प्रतिभाएं चुनें',
  filterBySpecificCandidates: 'विशिष्ट उम्मीदवारों द्वारा फिल्टर करें (वैकल्पिक)',
  talentSelection: 'प्रतिभा चयन',
  priority: 'प्राथमिकता',
  addComment: 'टिप्पणी जोड़ें',
  taskDetails: 'कार्य विवरण',
  summary: 'सारांश',
  addMeeting: 'मीटिंग जोड़ें',

  podAutomation: 'POD स्वचालन',
  uploading: 'अपलोड हो रहा है...',
  uploadFile: 'फाइल अपलोड करें',
  send: 'भेजें',
  submitting: 'सबमिट हो रहा है...',
  enterYourQuestionHere: 'यहां अपना प्रश्न दर्ज करें',
  submitTheResults: 'परिणाम सबमिट करें',
  export: 'निर्यात',
  podInsights: 'POD अंतर्दृष्टि',
  askQuestionsAboutYourPod: 'अपनी POD गतिविधियों, टीम सदस्यों आदि के बारे में प्रश्न पूछें',
  welcomeToPodInsights: 'POD अंतर्दृष्टि में आपका स्वागत है!',
  startByAskingQuestionsLike: 'इस तरह के प्रश्न पूछकर शुरुआत करें',
  showAllPodActivitiesThatHadBlockers: 'अवरोधक वाली सभी POD गतिविधियां दिखाएं',
  listAllCandidatesAndTheirPods: 'सभी उम्मीदवारों और उनके POD की सूची बनाएं',
  showStakeholdersFromIndia: 'भारत के हितधारकों को दिखाएं',
  askAnythingAboutYourPods: 'अपने POD, टीम सदस्यों, गतिविधियों के बारे में कुछ भी पूछें...',
  sending: 'भेजा जा रहा है...',
  analyzingYourQuestion: 'आपके प्रश्न का विश्लेषण किया जा रहा है...',
  pipelineCICD: 'पाइपलाइन CI/CD',
  tickets: 'टिकट',
  metricName: 'मेट्रिक नाम',
  metricValue: 'मेट्रिक मान',
  commentsHistory: 'टिप्पणी इतिहास',
  noCommentsYet: 'अभी तक कोई टिप्पणी नहीं',
  writeAComment: 'एक टिप्पणी लिखें...',
  solutionManagement: 'समाधान प्रबंधन',
  searchSolutions: 'समाधान खोजें...',
  refresh: 'रिफ्रेश',
  createNewSolution: 'नया समाधान बनाएं',
  solutionName: 'समाधान नाम',
  solutionDescription: 'समाधान विवरण',
  updateSolution: 'समाधान अपडेट करें',
  createSolution: 'समाधान बनाएं',
  confirmSolutionDeletion: 'क्या आप वाकई समाधान को हटाना चाहते हैं',
  artManagement: 'ART प्रबंधन',
  podManagement: 'POD प्रबंधन',
  searchPods: 'POD खोजें...',
  viewPod: 'POD देखें',
  searchARTs: 'ART खोजें...',
  noARTsFound: 'कोई ART नहीं मिले। "नया ART बनाएं" बटन पर क्लिक करके अपना पहला ART बनाएं।',
  createNewART: 'नया ART बनाएं',
  selectGig: 'गिग चुनें',
  artName: 'ART नाम',
  artDescription: 'ART विवरण',
  createART: 'ART बनाएं',
  confirmDeletion: 'हटाने की पुष्टि करें',
  confirmARTDeletion: 'क्या आप वाकई ART को हटाना चाहते हैं',
  primaryLanguage: 'प्राथमिक भाषा',
  selectSkills: 'कौशल चुनें',
  timeZone: 'समय क्षेत्र',
  updateART: 'ART अपडेट करें',
  somethingWentWrong: 'कुछ गलत हुआ',
  reloadPage: 'पृष्ठ फिर से लोड करें',
  privatePods: 'निजी POD',
  activePods: 'सक्रिय POD',
  completedPods: 'पूर्ण POD',
  pendingPods: 'लंबित POD',
  loadingPods: 'POD लोड हो रहे हैं...',
  retry: 'फिर से कोशिश करें',
  noPodsFound: 'कोई POD नहीं मिले',
  createFirstPod: 'शुरुआत करने के लिए अपना पहला POD बनाएं',
  previous: 'पिछला',
  showing: 'दिखाया जा रहा है',
  size: 'आकार',
  teamSize: 'टीम का आकार',
  activeMembers: 'सक्रिय सदस्य',
  stakeholders: 'हितधारक',
  podManagers: 'POD प्रबंधक',
  addManager: 'प्रबंधक जोड़ें',
  podManager: 'POD प्रबंधक',
  noManagersAssignedYet: 'अभी तक कोई प्रबंधक नियुक्त नहीं किया गया',
  addManagersToHelpOversee: 'इस POD की निगरानी में सहायता के लिए प्रबंधक जोड़ें',
  noStakeholdersYet: 'अभी तक कोई हितधारक नहीं',
  settings: 'सेटिंग्स',
  deletePod: 'POD हटाएं',
  addPodManager: 'POD प्रबंधक जोड़ें',
  selectManagerToInvite: 'इस POD में आमंत्रित करने के लिए एक प्रबंधक चुनें:',
  noManagersAvailableToInvite: 'आमंत्रित करने के लिए कोई प्रबंधक उपलब्ध नहीं।',
  selectAManager: 'एक प्रबंधक चुनें',
  selectedManager: 'चयनित प्रबंधक',
  inviteManager: 'प्रबंधक को आमंत्रित करें',
  noTeamMembersYet: 'अभी तक कोई टीम सदस्य नहीं',
  startByInvitingMembers: 'अपने POD में सदस्यों को आमंत्रित करके शुरुआत करें',
  inviteTeamMembers: 'टीम सदस्यों को आमंत्रित करें',
  existingMembers: 'मौजूदा सदस्य',
  inviteByEmail: 'ईमेल द्वारा आमंत्रित करें',
  searchByNameOrSkills: 'नाम या कौशल द्वारा खोजें...',
  optionalSelectUserToNotify: 'वैकल्पिक: Slack के माध्यम से सूचित करने के लिए एक उपयोगकर्ता चुनें',
  pleaseSelectPodToEnableFields: 'अन्य फ़ील्ड सक्षम करने के लिए कृपया POD चुनें',
  selectedCandidates: 'चयनित उम्मीदवार',
  selectCandidatesToInvite: 'इस POD में आमंत्रित करने के लिए उम्मीदवार चुनें',
  availableCandidates: 'उपलब्ध उम्मीदवार',
  inviteNewMembersByEmail: 'ईमेल द्वारा नए सदस्यों को आमंत्रित करें',
  emailAddresses: 'ईमेल पते',
  enterEmailAddresses: 'ईमेल पते दर्ज करें (कॉमा से अलग करें)',
  hidePodTeamMembers: 'POD खोजें अनुभाग में इस POD टीम सदस्यों को छुपाएं (वर्तमान में दृश्यमान)',
  technicalDetails: 'तकनीकी विवरण',
  currentTeamSize: 'वर्तमान टीम का आकार',
  communicationDetails: 'संचार विवरण',
  podReview: 'POD समीक्षा',
  rating: 'रेटिंग',
  writeReview: 'समीक्षा लिखें',
  shareYourExperience: 'इस POD के साथ अपना अनुभव साझा करें...',
  submitReview: 'समीक्षा सबमिट करें',
  viewPod: 'POD देखें',
  managePod: 'POD प्रबंधन',
  editPod: 'POD संपादित करें',
  skillsAndExperience: 'कौशल और अनुभव',
  reviews: 'समीक्षाएं',
  documents: 'दस्तावेज़',
  otherInfo: 'अन्य जानकारी',
  noWorkExperienceDataAvailable: 'कोई कार्य अनुभव डेटा उपलब्ध नहीं',
  selectART: 'ART चुनें',
  selectAnART: 'एक ART चुनें',
  jiraConfiguration: 'Jira कॉन्फ़िगरेशन',
  jiraProjectKey: 'Jira प्रोजेक्ट कुंजी',
  jiraURL: 'Jira URL',
  jiraAdminEmail: 'Jira व्यवस्थापक ईमेल',
  jiraAdminAPIToken: 'Jira व्यवस्थापक API टोकन',
  jiraOpenStoryBugStatus: 'Jira खुली कहानी/बग स्थिति',
  jiraClosedStoryBugStatus: 'Jira बंद कहानी/बग स्थिति',
  gitHubConfiguration: 'GitHub कॉन्फ़िगरेशन',
  gitHubUsername: 'GitHub उपयोगकर्ता नाम',
  gitHubAPIToken: 'GitHub API टोकन',
  gitHubRepositoryName: 'GitHub रिपॉजिटरी नाम',
  circleCIConfiguration: 'CircleCI कॉन्फ़िगरेशन',
  circleCIGitHubUsername: 'CircleCI GitHub उपयोगकर्ता नाम',
  circleCIGitHubRepository: 'CircleCI GitHub रिपॉजिटरी',
  circleCIAPIToken: 'CircleCI API टोकन',
  sonarQubeConfiguration: 'SonarQube कॉन्फ़िगरेशन',
  sonarQubeCloudURL: 'SonarQube क्लाउड URL',
  sonarQubeAPIToken: 'SonarQube API टोकन',
  awsConfiguration: 'AWS कॉन्फ़िगरेशन',
  awsAccessKeyID: 'AWS एक्सेस कुंजी ID',
  awsSecretAccessKey: 'AWS गुप्त एक्सेस कुंजी',
  awsRegion: 'AWS क्षेत्र',
  bitBucketConfiguration: 'BitBucket कॉन्फ़िगरेशन',
  bitBucketUsername: 'BitBucket उपयोगकर्ता नाम',
  bitBucketAppPassword: 'BitBucket ऐप पासवर्ड',
  bitBucketWorkspace: 'BitBucket कार्यक्षेत्र',
  openAIConfiguration: 'OpenAI कॉन्फ़िगरेशन',
  openAIToken: 'OpenAI टोकन',
  storyPointsCalculation: 'कहानी बिंदु गणना',
  uploadStoryPointsCalculationFile: 'कहानी बिंदु गणना फाइल अपलोड करें',
  currentFile: 'वर्तमान फाइल',
  notifications: 'सूचनाएं',
  markAllAsRead: 'सभी को पढ़ा हुआ चिह्नित करें',
  tryAgain: 'फिर से कोशिश करें',
  noNotificationsToDisplay: 'प्रदर्शित करने के लिए कोई सूचना नहीं',
  viewAllNotifications: 'सभी सूचनाएं देखें',
  enterMultipleEmailsSeparatedByCommas: 'कॉमा से अलग करके कई ईमेल दर्ज करें',
  addEmailAddressesToInvite: 'नए सदस्यों को आमंत्रित करने के लिए ईमेल पते जोड़ें',
  emailInvitationGuidelines: 'ईमेल निमंत्रण दिशानिर्देश',
  inviteesWillReceiveInstructions: 'आमंत्रित व्यक्तियों को इस POD में शामिल होने के निर्देश प्राप्त होंगे',
  theyWillNeedToCreateAccount: 'यदि उनके पास पहले से खाता नहीं है तो उन्हें एक खाता बनाना होगा',
  noCandidatesAvailable: 'कोई उम्मीदवार उपलब्ध नहीं',
  sendEmailInvites: 'ईमेल निमंत्रण भेजें',

  processingDataAndGeneratingInsights: 'डेटा प्रोसेसिंग और अंतर्दृष्टि जेनरेट की जा रही है',
  retroHistory: 'रेट्रो इतिहास',
  filterByMember: 'सदस्य द्वारा फिल्टर करें',
  podProductivity: 'POD उत्पादकता',
  totalTasks: 'कुल कार्य',
  completed: 'पूर्ण',
  clearFilters: 'फिल्टर साफ़ करें',
  totalActivities: 'कुल गतिविधियां',
  pendingApproval: 'अनुमोदन लंबित',
  sortBy: 'इसके अनुसार क्रमबद्ध करें',
  editSolution: 'समाधान संपादित करें',
  cannotDeleteAssociatedWithARTs: 'हटाया नहीं जा सकता - ART के साथ संबद्ध',
  editART: 'ART संपादित करें',
  createdDate: 'निर्माण तारीख',
  podDetails: 'POD विवरण',
  currentARTProject: 'वर्तमान ART/प्रोजेक्ट',
  artProject: 'ART/प्रोजेक्ट',
  selectAvailability: 'उपलब्धता चुनें',
  selectSkill: 'कौशल चुनें',
  selectTimezone: 'समय क्षेत्र चुनें',
  selectLocation: 'स्थान चुनें',
  selectBudget: 'बजट चुनें',
  podMember: 'POD सदस्य',
  addToPod: 'POD में जोड़ें',
  talentDetails: 'प्रतिभा विवरण',
  reviewsFeedback: 'समीक्षा और फीडबैक',
  noEducationDataAvailable: 'कोई शिक्षा डेटा उपलब्ध नहीं',
  noCertificationDataAvailable: 'कोई प्रमाणन डेटा उपलब्ध नहीं',
  clientReview: 'क्लाइंट समीक्षा',
  noReviewsAvailableYet: 'अभी तक कोई समीक्षा उपलब्ध नहीं',
  noClientReviews: 'इस प्रतिभा को अभी तक कोई क्लाइंट समीक्षा नहीं मिली है',
  resumeAvailable: 'रिज्यूमे उपलब्ध',
  viewDownloadResume: 'उम्मीदवार का रिज्यूमे देखें या डाउनलोड करें',
  noResumeAvailable: 'कोई रिज्यूमे उपलब्ध नहीं',
  noResumeUploaded: 'इस प्रतिभा ने रिज्यूमे अपलोड नहीं किया है।',
  codingAssessment: 'कोडिंग आकलन',
  assessmentAvailable: 'आकलन उपलब्ध',
  viewAssessmentResults: 'उम्मीदवार के कोडिंग आकलन परिणाम देखें',
  noAssessmentAvailable: 'कोई आकलन उपलब्ध नहीं',
  noAssessmentCompleted: 'इस प्रतिभा ने कोडिंग आकलन पूरा नहीं किया है।',
  partnerCompanyDetails: 'साझेदार कंपनी विवरण',
  companyIntroductionVideo: 'कंपनी परिचय वीडियो',
  videoNotSupported: 'आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता।',
  location: 'स्थान',
  noPodsMatchingCriteria: 'आपके मानदंडों से मेल खाने वाले कोई POD नहीं मिले',
  hirePod: 'POD किराए पर लें',
  notificationHistory: 'सूचना इतिहास',
  filter: 'फिल्टर',
  allNotifications: 'सभी सूचनाएं',
  markSelected: 'चयनित को चिह्नित करें',
  unread: 'अपठित',
  noNotificationsFound: 'कोई सूचना नहीं मिली',
  searchNotifications: 'सूचनाएं खोजें...',
  subscriptionManagement: 'सब्स्क्रिप्शन प्रबंधन',
  choosePlanPrompt: 'एक ऐसी योजना चुनें जो आपकी आवश्यकताओं के लिए सबसे उपयुक्त हो और आपके बढ़ने के साथ स्केल करे',
  cancelSubscription: 'सब्स्क्रिप्शन रद्द करें',
  choosePlan: 'योजना चुनें',
  noPlansAvailable: 'कोई योजना उपलब्ध नहीं',
  noPlansHelpText: 'कृपया बाद में जांचें या सहायता के लिए सपोर्ट से संपर्क करें।',
  currentPlanDetails: 'वर्तमान योजना विवरण',
  renewalDate: 'नवीनीकरण तिथि',
  subscriptionId: 'सब्स्क्रिप्शन आईडी',
  paymentMethod: 'भुगतान विधि',
  cardHolder: 'कार्ड धारक',
  expires: 'समाप्त होती है',
  brand: 'ब्रांड',
  billingHistory: 'बिलिंग इतिहास',
  noInvoiceHistory: 'कोई चालान इतिहास उपलब्ध नहीं',
  needHelp: 'सहायता चाहिए?',
  supportText: 'यदि आपके पास हमारी सब्स्क्रिप्शन योजनाओं के बारे में कोई प्रश्न हैं या सहायता की आवश्यकता है, तो हमारी सपोर्ट टीम आपकी मदद के लिए यहाँ है।',
  contactSupport: 'सपोर्ट से संपर्क करें',
  completeSubscription: 'अपना सब्स्क्रिप्शन पूरा करें',
  planDetails: 'योजना विवरण',
  planName: 'योजना का नाम',
  basePrice: 'मूल मूल्य',
  numberOfUsers: 'उपयोगकर्ताओं की संख्या',
  billingCycle: 'बिलिंग चक्र',
  orderSummary: 'ऑर्डर सारांश',
  annualDiscount: 'वार्षिक छूट',
  billingPeriod: 'बिलिंग अवधि',
  tax: 'कर',
  totalWithTax: 'कर के साथ कुल',
  annually: 'वार्षिक',
  continue: 'जारी रखें',
  subscriptionSuccessful: 'सब्स्क्रिप्शन सफल!',
  thankYouSubscribing: 'सब्स्क्राइब करने के लिए धन्यवाद',
  subscriptionActivated: 'आपका सब्स्क्रिप्शन सफलतापूर्वक सक्रिय हो गया है।',
  goToDashboard: 'डैशबोर्ड पर जाएं',
  addPaymentMethod: 'भुगतान विधि जोड़ें',
  cardNumber: 'कार्ड नंबर',
  cardholderName: 'कार्डधारक का नाम',
  expiryMonth: 'समाप्ति माह',
  expiryYear: 'समाप्ति वर्ष',
  postalCode: 'पोस्टल कोड',
  addCard: 'कार्ड जोड़ें',
  paymentChoice: 'मौजूदा कार्ड का उपयोग करें या नया कार्ड जोड़ें',
  existingCardText: 'आपके पास पहले से ही एक मौजूदा कार्ड है जो इसमें समाप्त होता है',
  useExistingCardPrompt: 'क्या आप इसे इस सब्स्क्रिप्शन के लिए उपयोग करना चाहेंगे?',
  useExistingCard: 'मौजूदा कार्ड का उपयोग करें',
  addNewCard: 'नया कार्ड जोड़ें',
  processing: 'प्रसंस्करण...',
  subscriptionSuccessDetails: 'सफल रहा!',
  accessAllFeatures: 'अब आप अपनी सब्स्क्रिप्शन योजना में शामिल सभी सुविधाओं का उपयोग कर सकते हैं।',
  editCardDetails: 'कार्ड विवरण संपादित करें',
  managerInvite: 'प्रबंधक निमंत्रण',
  talentInvite: 'प्रतिभा निमंत्रण',
  invitePodManagers: 'पॉड प्रबंधकों को आमंत्रित करने के लिए ई-मेल दर्ज करें',
  enterEmail: 'ई-मेल दर्ज करें',
  invite: 'आमंत्रित करें',
  yourInvoices: 'आपके चालान',
  getCountIsseswithNoCritria: 'स्वीकृति मानदंड के बिना मुद्दों की संख्या प्राप्त करें',
  noInvoices: 'आपके पास कोई चालान नहीं है।',
  amountDue: 'देय राशि',
  amountPaid: 'भुगतान की गई राशि',
  noActiveSubscription: 'आपके पास कोई सक्रिय सब्स्क्रिप्शन योजना नहीं है। कृपया सब्स्क्रिप्शन जोड़ने के लिए "सब्स्क्राइब" लिंक पर क्लिक करें।',
 noActiveSubscriptionStart: 'आपके पास कोई सक्रिय सब्स्क्रिप्शन योजना नहीं है। कृपया',
  subscribe: 'सब्स्क्राइब',
  noActiveSubscriptionEnd: 'लिंक पर क्लिक करके सब्स्क्रिप्शन जोड़ें।'};

export default messagesHi;